import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: '8px',
  paddingBottom: '8px',
}));
